import React from "react"
import CardCompaniesHomePage from "../cards/card-companies-homepage.js"

const StreamCompaniesHomePage = () => (
    <CardCompaniesHomePage />
)

export default StreamCompaniesHomePage
